import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { MessageSquareText, ChevronDown } from "lucide-react";
import { CommunicationHistory } from "@/components/orders/CommunicationHistory";
import { cn } from "@/lib/utils";

interface OrderCommunicationCardProps {
  orderId: string;
  customerId?: string;
}

export function OrderCommunicationCard({ orderId, customerId }: OrderCommunicationCardProps) {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Card>
      <Collapsible open={isOpen} onOpenChange={setIsOpen}>
        <CardHeader className="pb-3">
          <CollapsibleTrigger className="flex w-full items-center justify-between hover:opacity-80 transition-opacity">
            <CardTitle className="flex items-center gap-2">
              <MessageSquareText className="h-5 w-5" />
              Viestintähistoria
            </CardTitle>
            <ChevronDown 
              className={cn(
                "h-4 w-4 text-muted-foreground transition-transform duration-200",
                isOpen && "rotate-180"
              )} 
            />
          </CollapsibleTrigger>
        </CardHeader>
        <CollapsibleContent>
          <CardContent className="pt-0">
            <CommunicationHistory 
              orderId={orderId} 
              customerId={customerId}
              maxHeight="350px"
            />
          </CardContent>
        </CollapsibleContent>
      </Collapsible>
    </Card>
  );
}
